










import { Component, Vue } from "vue-property-decorator";
import { Constants, Console, Events } from "@/common/global.ts";

import BaseView from "@/common/base-view.ts";

@Component
export default class Background extends BaseView {

    private interval: number = 0;

    /**
     * Layer references
     *
     * @type {[type]}
     */
    private layers: any = [];

    /**
     * Distances
     *
     * @type {[type]}
     */
    private distances: any = [-40, -35, -20, -10];

    /**
     * Delta for layers
     *
     * @type {[type]}
     */
    private d: any = {
        x: [0, 0, 0, 0],
        y: [0, 0, 0, 0],
    };

    /**
     * Target for layers
     *
     * @type {[type]}
     */
    private t: any = {
        x: [0, 0, 0, 0],
        y: [0, 0, 0, 0],
    };

    /**
     *
     */
    public mounted(): void {
        this.layers = [
            <HTMLDivElement> this.$refs.layerAllInOne,
            // <HTMLDivElement> this.$refs.layerStars,
            // <HTMLDivElement> this.$refs.layerClouds,
            // <HTMLDivElement> this.$refs.layerDust,
            // <HTMLDivElement> this.$refs.layerGradient,
        ];

        // Disable/Enable animations
        if (Constants.ANIMATE_BACKGROUND) {
            this.attachEvents();
        }

        // Permanent events
        window.addEventListener(Events.BACKGROUND_PAUSE, this.Handle_OnPause);
        window.addEventListener(Events.BACKGROUND_PLAY, this.Handle_OnPlay);
    }

    /**
     * [attachEvents description]
     */
    public attachEvents() {
        document.addEventListener("mousemove", this.Handle_OnMouseMove.bind(this));

        this.interval = setInterval(this.Handle_OnInterval.bind(this), 1000 / 30);
    }

    /**
     * [detachEvents description]
     */
    public detachEvents() {
        document.removeEventListener("mousemove", this.Handle_OnMouseMove.bind(this));

        clearInterval(this.interval);
        this.interval = 0;
    }

    /**
     * lerp
     */
    private lerp(start: number, end: number, amt: number): number {
        return (1 - amt) * start + amt * end;
    }


    // Event Handlers
    // -----------------------------------------------------------------

    private Handle_OnPause(): void {
        this.detachEvents();

        this.log("On Pause");
    }

    private Handle_OnPlay(): void {
        this.attachEvents();

        this.log("On Play");
    }

    private Handle_OnInterval(): void {
        const amount: number = 0.05;

        for (let i: number = 0; i < this.layers.length; i++) {
            const layer: HTMLDivElement = this.layers[i];

            this.t.x[i] = this.lerp(this.t.x[i], this.d.x[i], amount);
            this.t.y[i] = this.lerp(this.t.y[i], this.d.y[i], amount);

            layer.style.transform = "translate(" + this.t.x[i] + "px, " + this.t.y[i] + "px)";
        }
    }

    private Handle_OnMouseMove(e: MouseEvent): void {
        const pageX: number = e.pageX;
        const pageY: number = e.pageY;
        const ratioX: number = pageX / window.innerWidth;
        const ratioY: number = pageY / window.innerHeight;

        for (let i: number = 0; i <= this.layers.length; i++) {
            this.d.x[i] = this.distances[i] * ratioX;
            this.d.y[i] = this.distances[i] * ratioY;
        }
    }

}
